import { Box } from "@mui/material";
import { memo } from "react";

import { ObjectNode } from "../types";
import { FieldLabel } from "./FieldLabel";
import { FieldRenderer } from "./FieldRenderer";

/*
 * An object's fields.
 * With `bare`, only the fields (the parent shows the title).
 */
export const ObjectField = memo(
  ({ node, bare = false }: { node: ObjectNode; bare?: boolean }) => {
    const fields = node.children.map((child) => (
      <FieldRenderer key={child.path} node={child} />
    ));

    if (bare) {
      return <>{fields}</>;
    }

    return (
      <Box sx={{ mb: 2 }}>
        <FieldLabel
          title={node.title}
          description={node.description}
          required={node.required}
        />

        <Box
          sx={{
            mt: 0.5,
            p: 2,
            pb: 0,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
          }}
        >
          {fields}
        </Box>
      </Box>
    );
  },
);

ObjectField.displayName = "ObjectField";
